module.exports = __webpack_public_path__ + "static/img/photo_camera.9df0911c.svg";